import React from "react";
import Image from "next/image";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components


import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styles from "../../../../services/ServicesSections.module.scss";




export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
      <a className={classes.anchor} id="start"></a>

      <div style={{textAlign: "center",maxWidth:"431px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 

                  <Image
                    layout = "responsive"
                    width = {431}
                    height = {350}
                    src="/img/posts/2018-02-25-humans-are-better-than-machines/1-resize.webp" 
                    alt="..."
                    className={imgClasses}
                  />

            </GridItem>
        </div>
      
        
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Learning That Humans Are Better Than Machines – Measurecamp Melbourne 2018 Talk</h3>
          <p> 
          Measurecamp Melbourne 2018 was held on Feb 24th 2018.
          <br /><br /> 
          My talk focused on the fallibility of machines and artificial intelligence. In my opinion, everyone is in a rush to develop an “intelligent model” to solve their business problems – without recognising such models are highly dependent on a number of factors as to their actual usefulness – most important of which is “who, or what is managing the model”?.
          <br /><br /> 
          The Human brain has 86 billion neurons, 100 trillion interconnections and 1000 proteins. Its been said that the entire internet can be replicated by one brain.
          <br /><br /> 
          Will an intelligent model solve all your problems – and if so what is the future for analysts?
          <br /><br /> 
          Slides here:        
          <br /><br /> 


          </p>
 
          </GridItem>

          <GridItem xs={12} sm={10} md={10}>
                <Card
                  raised
                  //background
                  //style={{
                  //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.jpg')",
                  //}}
                >
                  
                  <CardActionArea>
                    <CardMedia
                      component="iframe"
                      alt="Contemplative Reptile"
                      //className={classes.media}
                      height="500"
                      image="https://docs.google.com/presentation/d/e/2PACX-1vSJ-2yqBhCVfnOgnZvIwjAfLCPWQDBYxJgqSqNf_0ME_ajW1t5qPaKp94A50CNnojAp7bOw4b7tFOk1/embed?start=false&loop=false&delayms=3000"
                      //title="Contemplative Reptile"
                    />

                  </CardActionArea>
                </Card>  
                <p><br /><br /></p>       
              </GridItem>

        


      </GridContainer>
    </div>

  );
}
